<template>
  <div class="providers__meta">
    <ul class="icon-list">
      <li>
        <div class="flex flex-wrap">
          <MediaImage
            v-if="media"
            :media="media"
            :use-aspect="true"
            class="media--card"
          />
          <ServiceProvidersEaaaMemberBadge v-if="isEaaaMember" class="meta" />
        </div>
      </li>
      <template v-if="phonesFilled.length">
        <li
          v-for="phone in phonesFilled"
          :key="phone._uid"
          aria-label="Phone number"
        >
          <BlockPhone :blok="phone" />
        </li>
      </template>
      <li v-if="hasPhone" aria-label="Phone number">
        <i class="icon">
          <Icon name="fa6-solid:phone-flip" />
        </i>
        <span>
          {{ phone }}
        </span>
      </li>
      <li v-if="hasPhoneAlternate" aria-label="Phone number alternate">
        <i class="icon">
          <Icon name="fa6-solid:phone-flip" />
        </i>
        <span>
          {{ phoneAlternate }}
        </span>
      </li>
      <li v-if="hours" aria-label="Operating hours">
        <i class="icon">
          <Icon name="fa6-regular:clock" />
        </i>
        <span>
          {{ hours }}
        </span>
      </li>
      <li v-if="email" aria-label="Email">
        <a :href="'mailto:' + email">
          <i class="icon">
            <Icon name="fa6-regular:envelope" />
          </i>
          <span>
            {{ email }}
          </span>
        </a>
      </li>
      <li v-if="url">
        <a
          :aria-label="label"
          :gtm-service-provider="provider"
          :href="url"
          rel="external"
          target="_blank"
        >
          <i class="icon">
            <Icon name="fa6-solid:arrow-up-right-from-square" />
          </i>
          <span> Visit website </span>
        </a>
      </li>
      <li
        v-if="listedStates"
        aria-label="States and Territories this resource relates to"
        class="states"
      >
        <i class="icon icon--lg">
          <Icon name="fa6-solid:location-dot" />
        </i>
        <span>
          {{ listedStates }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { ServiceProvidersMetaProps } from './types'
const props = defineProps<ServiceProvidersMetaProps>()

const { label } = useServiceProvider(props)
const listedStates = computed(() => props.states?.join(', ') || 'National')
const phonesFilled = computed(() => {
  return props.phones?.filter((item) => item?.label || item?.phone) || []
})
const hasPhone = computed(() => !phonesFilled.value.length && !!props.phone)
const hasPhoneAlternate = computed(
  () => !phonesFilled.value.length && props.phoneAlternate,
)
</script>

<style lang="less" scoped>
.providers__meta {
  .rounded-sm();

  background: @color-fill-normal;
  padding: 0 @gutter-sm;
  max-width: @375px;
  ul {
    li {
      &.states {
        span {
          .uppercase();
        }
      }
    }
  }
}
</style>
